<!-- T11 — Confirmation modal -->
<div
  *ngIf="dialog"
  class="confirm-backdrop"
  (click)="onBackdropClick()"
  role="presentation"
>
  <div
    class="confirm-modal"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="'confirm-title-' + dialog.id"
    (click)="$event.stopPropagation()"
  >
    <h3 class="confirm-modal__title" [id]="'confirm-title-' + dialog.id">
      {{ dialog.title }}
    </h3>
    <div class="confirm-modal__body">
      {{ dialog.message }}
    </div>
    <div class="confirm-modal__actions">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="onCancel()"
      >
        {{ dialog.cancelText }}
      </button>
      <button
        type="button"
        class="btn"
        [class.btn-danger]="dialog.isDangerous"
        [class.btn-primary]="!dialog.isDangerous"
        (click)="onConfirm()"
        autofocus
      >
        {{ dialog.confirmText }}
      </button>
    </div>
  </div>
</div>
